import React from 'react'
import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import DeleteIcon from '@mui/icons-material/DeleteForever'
import { isFuture, parse as parseDate } from 'date-fns'
import { useStore } from '../../Store'
import { Field } from 'formik'
import { Button } from '@mui/material'

const MXContainer = styled('div')(({ theme }) => ({
  fontSize: '.75em',
  width: '100%',
  marginBottom: '20px',
  color: theme.palette.primary.main,
  gridArea: '1 / 2 / 2 / 4',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: '0 3rem',
    marginBottom: '1rem',
  },
  [theme.breakpoints.down('xs')]: {
    padding: '0 1rem',
  },
}))

const MXBorderStyle = styled('div')(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.primary.main}`,
  paddingRight: '1rem',
  paddingLeft: '1rem',
  display: 'grid',
  gridTemplateColumns: '3fr 3fr 3fr 1fr',
  gridGap: '5px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '1rem',
  },
  [theme.breakpoints.down('xs')]: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

const InputStyle = styled(TextField)({
  width: '100%',
  marginTop: '.5rem',
  '& div': {
    height: '40px',
  },
})

const TitleContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

function LegItem({ leg, formikProps, remove }) {
  const { values, handleChange, errors, setFieldValue } = formikProps
  const { aircraft, setAlertMessage } = useStore((state) => ({
    aircraft: state.aircraft,
    setAlertMessage: state.setAlertMessage,
  }))

  React.useEffect(() => {
    errors?.legs && console.log(errors.legs[0])
  }, [errors])

  const handleDateChange = (item) => {
    handleChange(item)
    const departureDate = parseDate(item.target.value, 'yyyy-MM-dd', new Date())
    const isValid = !isFuture(departureDate)
    if (!isValid) {
      setAlertMessage('Invalid date (It should be a past operation)')
      setFieldValue(`legs.${leg.number}.departureDate`, '')
    }
  }

  const handleAirportChange = (item, fieldName) => {
    const airportICAOCode = item.target.value.toUpperCase()
    const isValid = airportICAOCode.substring(0, 2) !== 'MM'
    if (!isValid) {
      setAlertMessage(
        'Airspace fee does not apply. Only flights that did not depart and/or land at a Mexican airport owe Mexican airspace fees.'
      )
      setFieldValue(`legs.${leg.number}.${fieldName}`, '')
    } else {
      setFieldValue(`legs.${leg.number}.${fieldName}`, airportICAOCode)
    }
  }

  return aircraft?.makeAndModel ? (
    <MXContainer>
      <TitleContainer>
        <h6>{`Leg #${leg.number + 1}`}</h6>
      </TitleContainer>
      <MXBorderStyle>
        <Field name={`legs.${leg.number}.departureDate`}>
          {(props) => (
            <InputStyle
              id={`legs.${leg.number}.departureDate`}
              name={`legs.${leg.number}.departureDate`}
              // error={!!errors?.legs && errors.legs[leg.number]?.errorMessage}
              // helperText={errors?.legs && errors.legs[leg.number]?.errorMessage}
              label="Departure Date*"
              variant="outlined"
              type="date"
              value={(values?.legs[leg.number] || {}).departureDate}
              onChange={handleDateChange}
              focused
            />
          )}
        </Field>
        <Field name={`legs.${leg.number}.departureAirport`}>
          {(props) => (
            <InputStyle
              id={`legs.${leg.number}.departureAirport`}
              name={`legs.${leg.number}.departureAirport`}
              error={!!errors?.legs && errors.legs[leg.number]?.errorMessage}
              helperText={errors?.legs && errors.legs[leg.number]?.errorMessage}
              label="Departure Airport*"
              variant="outlined"
              focused
              value={(values?.legs[leg.number] || {}).departureAirport}
              onChange={(e) => handleAirportChange(e, 'departureAirport')}
            />
          )}
        </Field>
        <Field name={`legs.${leg.number}.arrivalAirport`}>
          {(props) => (
            <InputStyle
              id={`legs.${leg.number}.arrivalAirport`}
              name={`legs.${leg.number}.arrivalAirport`}
              error={!!errors?.legs && errors.legs[leg.number]?.errorMessage}
              helperText={errors?.legs && errors.legs[leg.number]?.errorMessage}
              label="Arrival Airport*"
              variant="outlined"
              focused
              value={(values.legs[leg.number] || {}).arrivalAirport}
              onChange={(e) => handleAirportChange(e, 'arrivalAirport')}
            />
          )}
        </Field>
        {leg.number > 0 && (
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            style={{ textAlign: 'left' }}
            onClick={() => remove(leg.number)}
          >
            <DeleteIcon />
          </Button>
        )}
      </MXBorderStyle>
    </MXContainer>
  ) : (
    <></>
  )
}

export default LegItem
